import { render, staticRenderFns } from "./AppsDictionaryForm.vue?vue&type=template&id=4ff377d6"
import script from "./AppsDictionaryForm.vue?vue&type=script&lang=js"
export * from "./AppsDictionaryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports